import { IServiceDespesa } from "@fl/shared/src/types/services";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { InputActionMeta } from "react-select";
import { serviceDespesaSchema } from "../../../schemas/service";
import ApiCondominios from "../../../services/suporte/auth/condominios";
import { getSelectOptions } from "../../../utils/selectFuncs";
import SelectComp from "../../select/selectComp";

interface IProps {
  showModal: boolean;
  onResult: (data: any) => void;
}

type DespesaFormInputs = IServiceDespesa;

const ServiceDespesaModal: React.FC<IProps> = ({ showModal, onResult }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<DespesaFormInputs>({
    resolver: yupResolver(serviceDespesaSchema),
  });

  const [options, setOptions] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [loading, setLoading] = useState(false);

  const loadOptions = async (inputValue: string) => {
    if (inputValue.length >= 2) {
      setLoading(true);
      try {
        const result = await new ApiCondominios({ term: inputValue }).find();
        if (result.success) {
          const formattedOptions = getSelectOptions(
            result.data,
            "id_condominio_cond",
            `{st_nome_cond} [{st_cpf_cond}]`
          );
          setOptions(formattedOptions);
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setOptions([]);
    }
  };

  const handleSelectChange = (selectedOptions: any) => {
    // Atualiza o valor do campo `ids` no react-hook-form
    const ids = selectedOptions
      ? selectedOptions.map((opt: any) => opt.value)
      : [];
    setValue("ids", ids, { shouldValidate: true }); // Atualiza e valida o campo `ids`
  };

  const onSubmit = (data: DespesaFormInputs) => {
    onResult(data);
  };

  return (
    <Modal
      show={showModal}
      onHide={() => onResult(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Parâmetros de Atualização de Despesas
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="container-text text-jsutify">
        <form>
          <div className="mb-3">
            <label htmlFor="selectCondominios">Condomínios</label>
            <SelectComp
              isMulti={true}
              options={options}
              isLoading={loading}
              onInputChange={(
                newValue: string,
                actionMeta: InputActionMeta
              ) => {
                loadOptions(newValue);
              }}
              placeholder="Digite o nome ou CPF/CNPJ do condomínio"
              onChange={handleSelectChange} // Atualiza o valor no form
            />
            {errors.ids && <p className="text-danger">{errors.ids.message}</p>}
          </div>

          <div className="mb-3">
            <label htmlFor="date_from">Data de Início</label>
            <input
              type="date"
              {...register("date_from")}
              className={`form-control ${errors.date_from ? "is-invalid" : ""}`}
            />
            {errors.date_from && (
              <p className="text-danger">{errors.date_from.message}</p>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="date_to">Data Final</label>
            <input
              type="date"
              {...register("date_to")}
              className={`form-control ${errors.date_to ? "is-invalid" : ""}`}
            />
            {errors.date_to && (
              <p className="text-danger">{errors.date_to.message}</p>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="add_days">Adicionar Dias</label>
            <input
              type="number"
              {...register("add_days")}
              className={`form-control ${errors.add_days ? "is-invalid" : ""}`}
            />
            {errors.add_days && (
              <p className="text-danger">{errors.add_days.message}</p>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-between"
        >
          <Button
            variant="danger"
            type="submit"
            onClick={() => onResult(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="success"
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            Confirmar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ServiceDespesaModal;
